import { useState } from 'react';

export const useTrackEvents = (initial) => {
  const eventNames = [
    { key: 'SCHEDULED', displayName: 'Scheduled' },
    { key: 'ON_ITS_WAY', displayName: 'On its way' },
    { key: 'DELIVERED', displayName: 'Delivered' },
    { key: 'DELIVERED_AT_NEIGHBOUR', displayName: 'Delivered at neighbour' },
    { key: 'DELIVERY_FAILED', displayName: 'Delivery failed' },
    { key: 'RETURNED', displayName: 'Delivery returned to sender' },
  ];
  const [events, setEvents] = useState(
    eventNames.map((n, i) => {
      const existing = initial?.find((e) => e.keyword === n.key);
      return {
        index: i,
        key: n.key,
        name: n.displayName,
        on: existing?.on || false,
        subject: existing?.subject || '',
        body: existing?.body || '',
        closing: existing?.closing || '',
      };
    }),
  );

  const toggleEvent = (index) => {
    setEvents([...events.map((e, i) => (i === index ? { ...e, on: !e.on } : e))]);
  };
  const updateEvent = ({ index, field, value }) =>
    setEvents([...events.map((e, i) => (i === index ? { ...e, [field]: value } : e))]);

  const initialize = (initial) => {
    setEvents(
      eventNames.map((n, i) => {
        const existing = initial?.find((e) => e.keyword === n.key);
        return {
          index: i,
          key: n.key,
          name: n.displayName,
          on: existing?.value === 'true' || false,
          subject: existing?.extraData.subject || '',
          body: existing?.extraData.body || '',
          closing: existing?.extraData.closing || '',
        };
      }),
    );
  };
  return {
    eventNames,
    events,
    toggleEvent,
    updateEvent,
    initialize,
  };
};
